module.exports = __webpack_public_path__ + "static/media/couple-laptop.a1846159.jpg";